import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Header = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e127tk4q0"
} : {
  target: "e127tk4q0",
  label: "Header"
})(process.env.NODE_ENV === "production" ? {
  name: "tbffvn",
  styles: "display:flex;justify-content:flex-start;align-items:baseline;gap:8px"
} : {
  name: "tbffvn",
  styles: "display:flex;justify-content:flex-start;align-items:baseline;gap:8px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDaUMiLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuZXhwb3J0IGNvbnN0IEhlYWRlciA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gIGFsaWduLWl0ZW1zOiBiYXNlbGluZTtcbiAgZ2FwOiA4cHg7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SGVhZGVyLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});